import React from 'react';
import {
  StyledBannerContainer,
  StyledNewLink,
  StyledNavText,
  StyledSubText,
  StyledArrowIcon,
  StyledMobileCTALink,
  StyledDesktopLinks,
} from './AnnounceBanner.styles';
import { Box } from '@components/Box';
import { CTALink } from '@components/CTALink';
interface AnnounceBannerProps {
  page?: MarcomPageName;
}

export const AnnounceBanner = ({ page }: AnnounceBannerProps) => {
  return (
    <StyledBannerContainer alignItems="center" justifyContent="center">
      <StyledNewLink id="announceBannerNew" variant="altPurpleSecondary" forwardedAs="a" href="/registry">
        New
      </StyledNewLink>
      <Box marginRight={5} />
      <StyledMobileCTALink id="announceBannerMobile" variant="altPurple" href="/registry">
        <StyledNavText variant="caption" tagName="span" color="mono7">
          Discover the All-in-one Registry
        </StyledNavText>
      </StyledMobileCTALink>
      <StyledDesktopLinks>
        <CTALink id="announceBanner" variant="altPurple" href="/registry">
          <StyledNavText variant="caption" tagName="span" color="purple1">
            The All-in-one Registry
          </StyledNavText>
          <Box marginRight={5} />
          <StyledSubText variant="caption" tagName="span" color="purple1">
            {`A better way to build your dreams.`}
          </StyledSubText>
          <Box marginRight={5} />
          <StyledNavText variant="caption" tagName="span" color="mono7">
            <span style={{ whiteSpace: 'nowrap', marginRight: 8 }}>Learn More</span>
            <StyledArrowIcon />
          </StyledNavText>
        </CTALink>
      </StyledDesktopLinks>
    </StyledBannerContainer>
  );
};
